/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Owner_FirstInputs */

const cs_auth_signup_owner_first = /** @type {(inputs: Auth_Signup_Owner_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno majitele`)
};

const en_auth_signup_owner_first = /** @type {(inputs: Auth_Signup_Owner_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner first name`)
};

/**
* | output |
* | --- |
* | "Owner first name" |
*
* @param {Auth_Signup_Owner_FirstInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_owner_first = /** @type {((inputs?: Auth_Signup_Owner_FirstInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Owner_FirstInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_owner_first(inputs)
	return cs_auth_signup_owner_first(inputs)
});